<template>
  <SettingPanel title="Admin ticket assignment">
    <template #edit="{ done }">
      <TicketAssignmentManagement :value="selectedBot.ticket_v3_config" @close="done()" />
    </template>

    {{ currentTypeText }}
    {{ currentGroupStateText ? `/ ${currentGroupStateText}` : '' }}
    {{ currentAgentText ? `/ ${currentAgentText}` : '' }}
    {{ currentTicketStatusText ? `/ ${currentTicketStatusText}` : '' }}
    {{ currentCheckinStatusText ? `/ ${currentCheckinStatusText}` : '' }}
  </SettingPanel>
</template>

<script>
import SettingPanel from './SettingPanel.vue'
import TicketAssignmentManagement from './TicketAssignmentManagement.vue'
import { mapGetters } from 'vuex'
import { assignmentTypes } from '@/constants/ticket3/ticketConstant'

export default {
  components: { SettingPanel, TicketAssignmentManagement },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currentTypeText() {
      const { assign_ticket_type } = this.selectedBot.ticket_v3_config
      const type = assignmentTypes.find(({ value }) => value === assign_ticket_type)
      if (!type) return ''
      return type.label
    },
    currentGroupStateText() {
      const { assign_ticket_no_group } = this.selectedBot.ticket_v3_config
      return assign_ticket_no_group ? 'Assign without group' : ''
    },
    currentAgentText() {
      const { ticket_assign_previous_agent } = this.selectedBot.ticket_v3_config
      return ticket_assign_previous_agent ? 'Assign previous agent' : ''
    },
    currentTicketStatusText() {
      const { update_open_ticket } = this.selectedBot.ticket_v3_config
      return update_open_ticket ? 'Update open ticket' : ''
    },
    currentCheckinStatusText() {
      const { agent_check_in_auto } = this.selectedBot.ticket_v3_config
      return agent_check_in_auto ? 'Check-in automatically' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/TicketAssignment.vue